import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) return setState("error");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/market/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("error");
      } catch { return setState("error"); }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  return (
    <Shell testid={`payment-${state}`}>
      {state === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-primary" /><h1 className="mt-4 text-2xl font-extrabold">Confirmando pagamento...</h1></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" /><h1 className="mt-4 text-2xl font-extrabold">Pagamento confirmado!</h1><p className="mt-2 text-muted-foreground">O vendedor foi avisado e vai preparar seu pedido.</p></>}
      {state === "timeout" && <><Loader2 className="mx-auto h-12 w-12 text-primary" /><h1 className="mt-4 text-2xl font-extrabold">Ainda processando</h1><p className="mt-2 text-muted-foreground">Acompanhe o status em Minhas compras.</p></>}
      {state === "error" && <><XCircle className="mx-auto h-12 w-12 text-destructive" /><h1 className="mt-4 text-2xl font-extrabold">Pagamento não confirmado</h1></>}
      <Button asChild className="mt-6 rounded-full" data-testid="go-orders-btn"><Link to="/mercado/painel">Ver minhas compras</Link></Button>
    </Shell>
  );
}

export function PaymentCancel() {
  const [params] = useSearchParams();
  const listing = params.get("listing");
  return (
    <Shell testid="payment-cancelled">
      <XCircle className="mx-auto h-12 w-12 text-muted-foreground" />
      <h1 className="mt-4 text-2xl font-extrabold">Pagamento cancelado</h1>
      <p className="mt-2 text-muted-foreground">Nenhuma cobrança foi feita.</p>
      <Button asChild className="mt-6 rounded-full" data-testid="back-listing-btn"><Link to={listing ? `/mercado/anuncio/${listing}` : "/mercado"}>Voltar ao anúncio</Link></Button>
    </Shell>
  );
}

const Shell = ({ children, testid }) => (
  <div className="max-w-lg mx-auto px-4 py-20"><div data-testid={testid} className="rounded-2xl border border-border bg-card p-10 text-center">{children}</div></div>
);
